import React from 'react'

import LogoUFFS from './LogoUFFS.png'

export default () => {
  return (
    <div
      style={{
        margin: '1rem 0 1rem 0',
        textAlign: 'center',
      }}
    >
      <img
        alt="Logo da Universidade Federal da Fronteira Sul"
        title="Universidade Federal da Fronteira Sul - UFFS"
        src={LogoUFFS}
        style={{
          width: 300,
        }}
      />
    </div>
  )
}
